import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: "Boardline didn't just find me a role — they repositioned my entire career trajectory. In a market saturated with noise, their team cut through with surgical precision and placed me where I was meant to lead.",
    author: 'M.J., Chief Marketing Officer'
  }, {
    quote: 'The caliber of discretion and strategic counsel was extraordinary. Boardline operates at a level of sophistication that most firms simply cannot replicate. They understood the stakes before I had to explain them.',
    author: 'K.R., Managing Director'
  }, {
    quote: "What separates Boardline is their refusal to settle. They didn't present options — they presented the right opportunity. The one that aligned with my values, my ambition, and my legacy. That level of intentionality is rare.",
    author: 'S.L., Senior Vice President'
  }];
  return <Section background="navy" className="relative overflow-hidden" data-id="element-436">
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent-400/5 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2" data-id="element-437" />

      <FadeIn className="mb-16 text-center relative z-10" data-id="element-438">
        <span className="text-accent-400 text-xs font-bold uppercase tracking-[0.25em] block mb-4" data-id="element-439">
          In Their Words
        </span>
        <h2 className="text-3xl md:text-4xl font-serif text-sage-50 mb-4" data-id="element-440">
          Voices of Distinction
        </h2>
        <div className="h-[1px] w-24 bg-accent-400 mx-auto" data-id="element-441" />
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-442">
        {testimonials.map((item, index) => <FadeIn key={index} delay={index * 0.1} className="flex flex-col" data-id="element-443">
            <Quote className="w-8 h-8 text-accent-400 mb-6 opacity-40" data-id="element-444" />
            <p className="text-lg text-sage-200 font-serif italic leading-relaxed mb-6 flex-grow" data-id="element-445">
              "{item.quote}"
            </p>
            <div className="mt-auto" data-id="element-446">
              <div className="h-[1px] w-12 bg-white/[0.1] mb-4" data-id="element-447" />
              <p className="text-xs uppercase tracking-widest text-accent-300" data-id="element-448">
                {item.author}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}